import { RootState } from 'store/rootTypes';

export const BookingSelector = (state: RootState) => state.Booking;
